import { Invoice } from '../types';
import { InvoiceFormValues } from '../model';
import { invoiceCalculations } from './invoiceCalculations';

export function getInitialValuesFromExistingInvoice(invoice: Invoice): InvoiceFormValues {
  const { invoiceTotal, netFinanceAmount, netTrade, downPaymentFlat, downPaymentPercent } =
    invoiceCalculations.byInvoice(invoice);

  return {
    ...invoice,
    netTrade,
    invoiceTotal,
    netFinanceAmount,
    downPayment: { flat: downPaymentFlat, percent: downPaymentPercent },
  };
}
